/** Query params App Bridge / authenticate.admin need on embedded requests. */
const EMBEDDED_SESSION_PARAMS = [
  "shop",
  "host",
  "embedded",
  "id_token",
  "locale",
  "session",
] as const;

/**
 * Copy the current embedded session query onto a destination search string.
 * Dest-specific params (e.g. `tab=`) win; missing session params are filled
 * from the page the merchant is already on.
 */
export function withEmbeddedSearch(
  currentSearch: string,
  destSearch = "",
): string {
  const dest = new URLSearchParams(destSearch.replace(/^\?/, ""));
  const current = new URLSearchParams(currentSearch.replace(/^\?/, ""));
  for (const key of EMBEDDED_SESSION_PARAMS) {
    const value = current.get(key);
    if (value && !dest.has(key)) dest.set(key, value);
  }
  const search = dest.toString();
  return search ? `?${search}` : "";
}

/** Resolve an in-app href against the current origin and keep session params. */
export function embeddedHref(
  href: string,
  currentSearch: string,
  currentOrigin: string,
): string | null {
  let url: URL;
  try {
    url = new URL(href, currentOrigin);
  } catch {
    return null;
  }
  if (url.origin !== currentOrigin) return null;
  if (url.pathname !== "/app" && !url.pathname.startsWith("/app/")) return null;
  return `${url.pathname}${withEmbeddedSearch(currentSearch, url.search)}`;
}
